import { combineReducers } from 'redux'
import { InitReducer } from  './initReducer'
import { QryInputReducer } from './qryInputReducer'
import { RecentQryReducer } from './recentQryReducer'
import { MidSaveToReducer } from './midSaveToReducer'
//import { QryOutputReducer } from './qryOutputReducer'

function createReducer() {
  return combineReducers({
    InitQryFunc: InitReducer,
    QryInput: QryInputReducer,
    RecentQry: RecentQryReducer,
    MidSaveTo: MidSaveToReducer
    //QryOutput: QryOutputReducer
  });
}

export {
  createReducer
}
